<template>
  <div>
    <nav
      v-if="prev || next"
      class="border-t border-neutral-200 px-4 flex items-center justify-between sm:px-0"
    >
      <div
        v-if="prev"
        class="w-0 flex-1 flex items-center"
      >
        <a
          href="#"
          class="
            -mt-px border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-lg
            leading-5 font-medium text-neutral-600 hover:text-neutral-700 hover:border-neutral-300
            focus:outline-none focus:text-neutral-700 focus:border-neutral-400 transition
          "
          @click.prevent="$emit('prev', { page: getPrevPage })"
        >
          <svg
            class="mr-3 h-5 w-5 text-neutral-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
          {{ $t('app.previous') }}
        </a>
      </div>
      <div
        v-if="next"
        class="w-0 flex-1 flex items-center justify-end"
      >
        <a
          href="#"
          class="-mt-px border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-lg leading-5 font-medium text-neutral-600 hover:text-neutral-700 hover:border-neutral-300 focus:outline-none focus:text-neutral-700 focus:border-neutral-400 transition"
          @click.prevent="$emit('next', { page: getNextPage })"
        >
          {{ $t('app.next') }}
          <svg
            class="ml-3 h-5 w-5 text-neutral-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'VetsterPagination',

  props: {
    from: {
      type: [Number, String],
      default: 0,
    },
    to: {
      type: [Number, String],
      default: 0,
    },
    currentPage: {
      type: [Number, String],
      default: 0,
    },
    lastPage: {
      type: [Number, String],
      default: 0,
    },
    perPage: {
      type: [Number, String],
      default: 0,
    },
    total: {
      type: [Number, String],
      default: 0,
    },
    first: {
      type: [Number, String],
      default: 0,
    },
    last: {
      type: [Number, String],
      default: 0,
    },
    prev: {
      type: [Number, String],
      default: 0,
    },
    next: {
      type: [Number, String],
      default: 0,
    },
  },

  computed: {
    getNextPage() {
      return (this.next >= 1 && this.next) || 1;
    },
    getPrevPage() {
      return (this.prev > 1 && this.currentPage - 1) || 1;
    },
  },
};
</script>
